import { useEffect, useState, useRef } from 'react'
import { StorageModule } from '../../modules/storage';
import { userModule } from '../../modules/user';

import * as apis from '../../api/user'
import * as apis2 from '../../api/networkDisk'
import type { MenuProps } from 'antd';
import useStore from '../../store/useStore'

import LevelView from '../../components/level/index';
import './index.scss'
import SelectedExecutor from '../../components/executorList/selectedExecutor'
import MemoModal from '../../components/memos/memoModal'
import { PlusOutlined, } from '@ant-design/icons';
import { deepCopy, getImgUrlById, getCharCount } from '../../util';
import moment from "moment";
import {
    week,
    calcWeekDate,
    getNaturalMonthData,
    getMonthData,
    btnStyle,
    nowYear,
    nowMonth,
    Iprops,
    DateRet,
} from '../calendar/util';
interface Props {
    history: any;
}
interface State {
    userInfo: any,
    txtStr: any,

}
const TaskKanban = (props: Props) => {
    const { store, dispatch } = useStore();
    const [levelData_todo, setLevelDataTodo] = useState<any>(null);
    const [levelData_doing, setLevelDataDoing] = useState<any>(null);
    const [levelData_deal, setLevelDataDeal] = useState<any>(null);
    const [state, setState] = useState<State>({
        userInfo: {},
        txtStr: ""
    });
    //列表开始时间
    const [startDate, setStartDate] = useState<any>([]);
    const [txt, setTxt] = useState<any>('');

    const [memoVisible, setMemoVisible] = useState<boolean>(false);
    const [ids, setIds] = useState<any>([]);

    useEffect(() => {
        initAll()
        getId()
    }, [startDate, store.calendarExecutorRowKeys, store.calendarExecutor?.id, store.subjectCurType,])
    useEffect(() => {
        console.log('store.taskCalendarCurTimeType', store.taskCalendarCurTimeType)
        let _dataType = store.taskCalendarCurTimeType
        let _currentDate = moment(new Date()).format('YYYY-MM-DD')
        if (_dataType == 'week') {
            //取当周的起始时间
            setStartDate(calcWeekDate(_currentDate))
        } else if (_dataType == 'month') {
            //取当前月份
            console.log('取当前月份', moment(new Date()).format('YYYY'), moment(new Date()).format('MM'),)
            setStartDate(getNaturalMonthData(moment(new Date()).format('YYYY'), moment(new Date()).format('MM'), 1));

        } else if (_dataType == 'day') {
            //取当前日期
            setStartDate([_currentDate]);

        } else if (_dataType == 'season') {
            //算季度起始时间
            let start: any = moment(_currentDate).startOf('quarters').format('YYYY-MM-DD');
            let end: any = moment(_currentDate).endOf('quarters').format('YYYY-MM-DD')
            setStartDate([start, end]);
        } else if (_dataType == 'year') {
            setStartDate([moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')]);
        }
    }, [store.taskCalendarCurTimeType])
    const initAll = () => {
        init('任务计划')
        init('开始执行')
        init('任务完成')
    }
    const init = async (name: any) => {
        state.userInfo = StorageModule.getUser().user
        let params: any = {
            taskName: name,
            // topicId: store.subjectInfo.subjectId,
        }
        // params.executorIds = [state.userInfo.id]
        // 默认：executorIds = [当前登陆用户id]
        // 当前主题的任务：topicId = [当前主题id]
        // 全部：只有查询开始和结束时间，没有其他的请求参数。
        if (store.subjectCurType === 'default') {
            params.executorIds = [state.userInfo.id]
        }
        if (store.subjectCurType === 'current') {
            params.topicId = [store.subjectInfo?.subjectId]
        }
        if (store.subjectCurType === 'all') {
            delete params['executorIds']
        }
        if (store.calendarExecutorRowKeys.length > 0) {
            params.executorIds = store.calendarExecutorRowKeys
        }
        if (store.calendarExecutor?.id) {
            params.executorIds = store.calendarExecutor?.id
        }
        params.startDate = moment(startDate[0]).format('YYYY-MM-DDTHH:mm:[00]')
        params.endDate = moment(startDate[startDate.length - 1]).format('YYYY-MM-DDT[23]:[59]:[59]')

        const res: any = await apis.taskSearch(params);

        if (res.ok) {
            // let params = {
            //     data: {
            //         memos: res.data || [],
            //         hierarchyMax: null,
            //         memoId: '',
            //         ownerId: ''
            //     }
            // }
            let params = res.data
            if (name == '任务计划') {
                setLevelDataTodo(params || [])
            } else if (name == '开始执行') {
                setLevelDataDoing(params || [])
            } else if (name == '任务完成') {
                setLevelDataDeal(params || [])
            }
        }

    }
    const saveNode = async (e: any) => {
        try {

            console.log("saveNode", e, state.txtStr, store.subjectInfo)
            if (!state.txtStr) return
            if (ids.length === 1) {
                getId()
                setTimeout(() => {
                    saveNode(e)
                }, 500);
            }

            let params: any = deepCopy(store.subjectInfo.data)
            params.$operate$ = 'save'
            //增量传值，所以将memos、comments、relationBelongTos置空
            params.memos = [{
                $operate$: "save",
                content: state.txtStr,
                id: ids[0],
                ownerId: state.userInfo?.id,
                visible: true,
            }]

            params.comments = []
            params.relationBelongTos = []
            console.log('ss', params)

            let res: any = await apis2.putExcellingTopic(params.id, params)
            if (res.ok) {
                addTask(params.id)
            }
        } catch (e) { }
    }
    const addTask = async (id: any) => {
        let res: any = await apis2.putMemoNotation(ids[0], 'TaskTag', {
            executorId: state.userInfo?.id,
            finishTime: moment(new Date).format('YYYY-MM-DDT23:59:59'),
            manHour: "1",
            memoId: store.subjectInfo.data.memoId,
            name: "任务计划"
        })
        if (res.ok) {
            init('任务计划')
            ids.splice(0, 1)
            setIds(ids)
            setMemoVisible(false)
        }

    }
    const getId = async () => {
        let res: any = await apis2.sequenceSerial()
        if (res.ok) {
            let _ids = ids.concat(res.data);
            setIds(_ids)
        }
    }
    return (
        <div className='taskView'>
            <SelectedExecutor onClick={(e) => {
                console.log(e)
            }} />
            <div data-flex='main:justify cross:top'>
                <div className='task_item'>
                    <div data-flex='main:justify cross:center'>
                        <div className='itemBg itemBg1'>待处理</div>
                        {/* <PlusOutlined className='icon_hover mr-10' onClick={() => {
                            setMemoVisible(true)
                        }} /> */}
                    </div>
                    <LevelView name="待处理" hideMenu={true} treeData={levelData_todo} onRefresh={() => { initAll() }} />
                </div>
                <div className='task_item'>
                    <div data-flex='main:justify cross:top'>
                        <div className=' itemBg itemBg2'>处理中</div>
                    </div>
                    <LevelView name="处理中" hideMenu={true} treeData={levelData_doing} onRefresh={() => { initAll() }} />
                </div>
                <div className='task_item'>
                    <div data-flex='main:justify cross:top'>
                        <div className='itemBg itemBg3'>已处理</div>
                    </div>
                    <LevelView name="已处理" hideMenu={true} treeData={levelData_deal} onRefresh={() => { initAll() }} />
                </div>
            </div>
            {/* <MemoModal openVisible={true} onClose={() => { setMemoVisible(false) }} visible={memoVisible} saveNode={(e) => { saveNode(e) }} isAdd={true} operationType={'memos'} change={(e) => {
                // saveNode(e)
                setTxt(e)
                state.txtStr = e
                setState(state)
            }} /> */}
        </div>

    )
}

export default TaskKanban
